/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { Calculation } from "./Calculation";
export const ListCalculationsResponse = core.serialization.object({
    data: core.serialization.list(Calculation),
});
